import React from 'react'
import styled from 'styled-components'

const ContainerInput = styled.div<{ background: string, className: string }>`
    background: ${p => p.background};
    display: flex;
    justity-content: center;
    flex-direction: row;
    align-items: center;
    padding: 6px;
    border-radius: 5px;
    margin: 6px 4px;
    height: 50px;
    
    > div {
        min-width: 15px;
        margin-left: 5px;
        margin-right: 5px;
    }

    > div svg{
        color: ${p => p.theme.palette.primary.main};
    }

    > input{
        width: 100%;
        outline: none;
        border: none;
        background: ${p => p.background};
        padding:2px;
    }

    ${p => p.className}
`

interface IOwnProps{
    inputRef?: any;
    type: string;
    textHolder: string
    background?: string
    className?: string
    icon?: React.ReactElement
}

const InputTC: React.FunctionComponent<IOwnProps> = ({
    inputRef,
    type,
    icon,
    textHolder,
    background = '#F2F2F2',
    className = '',
    ...props
}) => {
  return (
    <ContainerInput background={background} className={className}>
        {!!icon && <div>{icon}</div>}
        <input ref={inputRef} type={type} placeholder={textHolder} {...props}></input>
    </ContainerInput>
  )
}

export default InputTC